import {
  StrictMode,
} from 'react';
import {
  createRoot,
} from 'react-dom/client';

import '#src/styles/fonts.scss'; // Font Styles
import '#src/styles/entry.client.scss'; // Application Styles
import '@mantine/core/styles.css'; // Component Base Styles
import '@mantine/notifications/styles.css'; // Notification Styles
import '@mantine/dates/styles.css'; // Calendar Styles

import '~console';
import {
  EntryComponent,
} from '#src/entry';
import {
  createRouter,
  type RouterType,
} from '#src/router';

export async function render(
  req,
  res,
) {
  // Create a router instance
  const router = createRouter();
  // Render the app
  const rootElement = document.getElementById('app');
  if (!rootElement) {
    throw new Error('Cannot get \'#app\' selector from document');
  }

  if (!rootElement.innerHTML) {
    const root = createRoot(rootElement);
    root.render(
      <StrictMode>
        <EntryComponent
          router={ router }
        />
      </StrictMode>,
    );
  }
}
